export class PasswordRequest{
  password = '';
  passwordConfirm = '';
  captchaResponse = '';
  passwordToken = '';
}
